document.addEventListener('DOMContentLoaded', () => {
  function waitForElements() {
    const cartIcon = document.querySelector('#cart-icon-bubble-mobile');
    const drawer = document.querySelector('cart-drawer');
    const closeButton = drawer?.querySelector('.drawer__close');

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      });
    }

    if (cartIcon && drawer) {
      console.log('Found cart icon and drawer');

      // Open drawer on cart icon click
      cartIcon.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
        refreshCartHTML(); // make sure it's fresh when opened
      });

      // Listen for quick add submit
      document.addEventListener('submit', function(e) {
        if (e.target.matches('.quick-add-form')) {
          e.preventDefault();
          const form = e.target;
          const variantId = form.querySelector('input[name="id"]').value;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(response => response.json())
          .then(() => {
            updateCartCount();
            refreshCartHTML(); // reload section HTML
            drawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
          });
        }
      });
    } else {
      console.log('Not yet found, retrying...');
      setTimeout(waitForElements, 300);
    }
  }

  // update cart badge
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  // reload the cart HTML section
  function refreshCartHTML() {
    fetch('/?section_id=main-cart-items')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCart = doc.querySelector('cart-items');
        const oldCart = document.querySelector('cart-items');
        if (newCart && oldCart) {
          oldCart.innerHTML = newCart.innerHTML;
        }
      })
      .catch(error => {
        console.error('Error refreshing cart HTML:', error);
      });
  }

  waitForElements();
});
